module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot7-4c8c8ab76a7afa56b36a3c40f18b4251.png";